import * as React from 'react';
import {
  calculateProgress,
  PrimaryActionButtonProps,
  primaryActionButtonProps,
} from './utils';
import * as registrationMachine from '../machines/accountRegistration';
import lang from '../lang';
import {UseMachineType} from '../machines/useAccountRegistrationMachineType';

type Props = {
  registrationMachine: UseMachineType;
};

type ScreenProps = Props & {
  lang: typeof lang.registrationSuccess;
  progress: number;
  firstname: string | null;
  cardNumber: string | null;
  linkedPracticeName: string | null;
  actionButtons: {
    primary: PrimaryActionButtonProps;
  };
  username: string | null;
  email: string | null;
};

export type RegistrationSuccessScreenType = React.ComponentType<ScreenProps>;

export function RegistrationSuccess(
  props: Props & {children: RegistrationSuccessScreenType}
) {
  const [
    {
      context: {
        account,
        account: {firstname, username, email},
        cardNumber,
        linkedPractice,
        navigator: {location},
      },
      matches,
    },
    send,
  ] = props.registrationMachine;

  const progress = calculateProgress({
    draftAccount: account,
    location,
  });

  const renderProps: ScreenProps = {
    ...props,
    lang: lang.registrationSuccess,
    progress,
    firstname,
    cardNumber,
    linkedPracticeName: linkedPractice?.name || null,
    actionButtons: {
      primary: primaryActionButtonProps({
        onClick: () => {
          send(registrationMachine.RegistrationEvent.GO_TO_ACCOUNT);
        },
        children: lang.registrationSuccess.buttons.primary.title,
        loading: matches({
          [registrationMachine.RegistrationState.success]:
            registrationMachine.RegistrationState.loggingInViaOauthTokens,
        }),
        disabled: false,
      }),
    },
    username,
    email,
  };

  const Screen = props.children;
  return <Screen {...renderProps} />;
}
